export default __webpack_public_path__ + "bc3c816.png";